import Vue from "vue";
import Router from "vue-router";
import Template from "@/components/Template";
import Welcome from "@/views/Welcome";
import Home from "@/views/Home";
import AppNav from "@/components/common/AppNav";

//租户管理
import ZuHuAllow from "@/views/navZuhu/zuhuAllow";
import ZuHu from "@/views/navZuhu/zuhu";

import DefaultMenu from "@/views/configureManagement/defaultMenu";
// import ZuHu from '@/views/navZuhu/zuhu'

//系统设置
import FunctionAuthorityList from "@/views/systemSet/functionAuthorityList";
import ParameterInfo from "@/views/systemSet/parameterInfo";
import PersonZuzhi from "@/views/systemSet/personZuzhi";
import RoleList from "@/views/systemSet/roleList";
import ShujuQuery from "@/views/systemSet/shujuQuery";
import ParameterInfoBusiness from "@/views/systemSet/parameterInfoBusiness";
import Scheduling from "@/views/systemSet/schedulingList";
import ExtAttrList from "@/views/extAttr/extAttrList";
//日志
/*业务日志*/
import RizhiLookup from "@/views/logging/rizhiLookup";
/*登录日志*/
import LoginLogging from "@/views/logging/loginLoggin";
/*异常*/
import ErrorLogging from "@/views/logging/errorLogging";
//系统公告
import MessageNotice from "@/views/systemSet/messageNotice";
//飞书维护
import FeishuApprove from "@/views/systemSet/feishuApprove";
//基础设置
import BasicsConfigure from "@/views/basicSetting/basicsConfigure";
import ColorSet from "@/views/basicSetting/colorSet";
import FaultSet from "@/views/basicSetting/faultSet";
import FaultOffer from "@/views/basicSetting/faultOffer";
import MaterClass from "@/views/basicSetting/materClass";
import MaterCode from "@/views/basicSetting/materCode";
import RepairModeManage from "@/views/basicSetting/repairModeManage";
import FaultRepair from "@/views/basicSetting/faultRepair";
import MaterBinding from "@/views/basicSetting/materBinding";
import ServiceSku from "@/views/basicSetting/serviceSku";
import ChannelManage from "@/views/basicSetting/channelManage";
import TrashRecoverManage from "@/views/basicSetting/trashRecoverManage";
import EngineerManage from "@/views/basicSetting/engineerManage";
import EngineerBasicPackage from "@/views/basicSetting/engineerBasicPackage";
import QuestionList from "@/views/basicSetting/questionList";
import QuestionFault from "@/views/basicSetting/questionFault";
import RegionManagerList from "@/views/basicSetting/regionManagerList";
import BusinessUserList from "@/views/basicSetting/businessUser";
import ModelAdapter from "@/views/basicSetting/modelAdapter";
// 基础设置 派单配置
import DispatchConfiguration from "@/views/basicSetting/dispatchConfiguration";
// import

//采购
import SupplierManage from "@/views/purchaseManage/supplierManage";
import ReturnGoodsManage from "@/views/purchaseManage/returnGoodsManage";
import ReturnGoodsInfo from "@/views/purchaseManage/returnGoodsInfo";
import PurchaseOrderManage from "@/views/purchaseManage/purchaseOrderManage";
import PurchaseOrderInfo from "@/views/purchaseManage/purchaseOrderInfo";
import NewPurchaseOrder from "@/views/purchaseManage/newPurchaseOrder";
import NewChangePurchaseOrder from "@/views/purchaseManage/newChangePurchaseOrder";

import PurchaseOrderChangeManage from "@/views/purchaseManage/purchaseOrderChangeManage";
import PurchaseOrderChangeInfo from "@/views/purchaseManage/purchaseOrderChangeInfo";
import NewPurchaseOrderChangeOrder from "@/views/purchaseManage/newPurchaseOrderChangeOrder";
import NewChangePurchaseOrderChangeOrder from "@/views/purchaseManage/newChangePurchaseOrderChangeOrder";
// 采购订单变更管理 采购订单变更详情  新建采购订单变更 采购订单变更详情(暂存) purchaseOrderChangeInfo

//客服
import CustomerServiceManage from "@/views/customerManage/customerServiceManage";

//门店
import StoreEngineerManage from "@/views/storeManage/storeEngineerManage";
import ShopManage from "@/views/storeManage/shopManage";

// 仓库管理
// 仓库对外管理
import AccessStoreManage from "@/views/storeManageOuter/accessStoreManage";
import NewAccessStore from "@/views/storeManageOuter/newAccessStore";
import AccessStoreInfo from "@/views/storeManageOuter/accessStoreInfo";
import EditAccessStore from "@/views/storeManageOuter/editAccessStore";

import MaterChangeStoreManage from "@/views/storeManageOuter/materChangeStoreManage";
import NewMaterChangeStore from "@/views/storeManageOuter/newMaterChangeStore";
import MaterChangeStoreInfo from "@/views/storeManageOuter/materChangeStoreInfo";

import MaterDeliveryManage from "@/views/storeManageOuter/materDeliveryManage";
import MaterReceiveManage from "@/views/storeManageOuter/materReceiveManage";
import MaterDeliveryInfo from "@/views/storeManageOuter/materDeliveryInfo";
import NewMaterDelivery from "@/views/storeManageOuter/newMaterDelivery";

//仓库对内管理
import PickingManage from "@/views/storehouseManage/pickingManage";
import NewPicking from "@/views/storehouseManage/newPicking";
import EditPicking from "@/views/storehouseManage/editPicking";
import PickingInfo from "@/views/storehouseManage/pickingInfo";
import ReturnMaterManage from "@/views/storehouseManage/returnMaterManage";
import ReturnMaterManageList from "@/views/storehouseManage/returnMaterManageList";
import ReturnMaterInfo from "@/views/storehouseManage/returnMaterInfo";
import NewReturnMater from "@/views/storehouseManage/newReturnMater";
import EditReturnMater from "@/views/storehouseManage/editReturnMater";
import ReturnMaterialSave from "@/views/storehouseManage/returnMaterialSave";
import ScrapProfitList from "@/views/storehouseManage/scrapProfitList";

import StockQuery from "@/views/storehouseManage/stockQuery";
import StockCheck from "@/views/storehouseManage/stockCheck";
import StockCheckInfo from "@/views/storehouseManage/stockCheckInfo";
import NewStockCheck from "@/views/storehouseManage/newStockCheck";
import EngineerStockQuery from "@/views/storehouseManage/engineerStockQuery";
import MaterExchange from "@/views/storehouseManage/materExchange";

import NewResidual from "@/views/storehouseManage/wasteManagement/newResidual";
import ResidualManage from "@/views/storehouseManage/wasteManagement/residualManage";
import ResidualManageInfo from "@/views/storehouseManage/wasteManagement/residualManageInfo";

import QuerySn from "@/views/storehouseManage/snList";

import MaterialSnBinder from "@/views/storehouseManage/materialSnBinderList";
//仓库管理 门店维修出入库
import EntryManage from "@/views/storehouseManage/storeManagement/entryManage";
import OutManage from "@/views/storehouseManage/storeManagement/outManage";
import UnEntryManage from "@/views/storehouseManage/storeManagement/unEntryManage";
import UnOutManage from "@/views/storehouseManage/storeManagement/unOutManage";

//派单
import DispatchManage from "@/views/dispatchOrder/dispatchManage";
import DispatchList from "@/views/dispatchOrder/dispatchList";
import UnDispatchList from "@/views/dispatchOrder/unDispatchList";
import DispatchLook from "@/views/dispatchOrder/dispatchLook";
import DispatchReady from "@/views/dispatchOrder/dispatchReady";
//工单 newWorkOrder workOrderInfo

import WorkOrderManage from "@/views/workOrder/workOrderManage";
import WorkOrderManageOther from "@/views/workOrder/workOrderManageOther";
import WorkOrderInfo from "@/views/workOrder/workOrderInfo";
import WorkOrderInfoExit from "@/views/workOrder/workOrderInfo_exit";
import VisitRepair from "@/views/workOrder/visitRepair";
import VisitService from "@/views/workOrder/visitService";
import ShopRepair from "@/views/workOrder/shopRepair";
import ShopService from "@/views/workOrder/shopService";
import NewWorkOrder from "@/views/workOrder/newWorkOrder";
import RefundManage from "@/views/workOrder/refundManage";
import BillingManage from "@/views/workOrder/billingManage";
import QuantityCalculation from "@/views/workOrder/quantityCalculation";

import WorkOrderManageRmk from "@/views/workOrder/workOrderManageRmk";
import WorkOrderManageShop from "@/views/workOrder/workOrderManageShop";
import StockQueryManage from "@/views/workOrder/stockQueryManage";
import EngineerStockQueryManage from "@/views/workOrder/engineerStockQueryManage";
import OrderMap from "@/views/workOrder/orderMap";
import ShopStoreOrderMap from "@/views/workOrder/shopStoreOrderMap";
import OrderCoordinateMap from "@/views/workOrder/orderCoordinateMap";

//财务中心
import RefundsManage from "@/views/financialCenter/refundsManage";
import InvocingManage from "@/views/financialCenter/invocingManage";
import ReconciliationManage from "@/views/financialCenter/reconciliationManage";
import FinancialInterest from "@/views/financialCenter/financialInterest";
import OrderDetail from "@/views/financialCenter/orderDetail";
import EngineerOrder from "@/views/financialCenter/engineerOrder";
import FundAuthManage from "@/views/financialCenter/fundAuthManage";

//客户管理
import CustomerListManage from "@/views/customerManagement/customerListManage";
import CustomerInfo from "@/views/customerManagement/customerInfo";

import FourZeFour from "@/views/404";
import notFound from "@/views/400";

import Login from "@/views/Login";
// import Register from '@/views/Register'
import HelpPage from "@/views/helpPage";
import fa from "element-ui/src/locale/lang/fa";
// import FindPassword from '@/views/FindPassword'
// 报表中心
import OrderReport from "@/views/finreport/orderReport";
//dbp报表
import BdpReport from "@/views/finreport/bdpReport";

//图文管理
import TweetPictures from "@/views/basicSetting/tweetPictures";

// 活动
import BizCoupon from "@/views/biz/coupon";
import BizCouponEdit from "@/views/biz/coupon/components/couponEdit";
import BizActivity from "@/views/biz/activity";
import BizSubscriber from "@/views/biz/subscriber";
import BizSubscriberDetail from "@/views/biz/subscriber/components/detail";
import SubscriberCoupon from "@/views/biz/subscriber/couponHistory";

// 门店活动
import StoreCoupon from "@/views/store/coupon";
import StoreActivity from "@/views/store/activity";
import StoreSubscriberCoupon from "@/views/store/subscriber/couponList";

// 权益卡
import BizPrivilegeCard from "@/views/biz/privilege/card";
import BizPrivilegePool from "@/views/biz/privilege/pool";
import SubscriberPrivilege from "@/views/biz/privilege/subscriber";

// 礼品卡
import BizGiftCard from "@/views/biz/giftCard";
import BizGiftCardRecord from "@/views/biz/giftCard/record";
import BizGiftCardBuyConfig from "@/views/biz/giftCard/buyConfig";
import BizGiftCardOrder from "@/views/biz/giftCard/order";
import BizGiftCardOrderRefund from "@/views/biz/giftCard/orderRefund";


//回收管理
import RecoveryProfit from "@/views/recovery/recoveryProfit";

//回收询价
import RecoveryParams from "@/views/recovery/recoveryParams";

//回收图文管理
import RecoveryPictures from "@/views/recovery/recoveryPictures";
// 回收-门店管理
import RecoveryShop from "@/views/recovery/recoveryShop";
// 回收-安卓包
import RecoveryShopApkVersion from "@/views/recovery/recoveryShopApkVersion";


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
      hidden: true
    },
    {
      path: "/loginOut",
      name: "loginOut",
      meta: { requireAuth: true, keepAlive: false },
      hidden: true
    },
    {
      path: "/helppage",
      name: "HelpPage",
      component: HelpPage,
      hidden: true
    },
    {
      path: "/404",
      name: "404",
      component: FourZeFour,
      hidden: true
    },
    // {
    //   path: '/400',
    //   name: '400',
    //   component: notFound,
    //   hidden: true
    // },
    {
      //meta: {requireAuth: true} 进入这个路由是需要登陆的  EngineerBasicPackage
      path: "/basicSetting",
      component: Home,
      name: "基础设置",
      children: [
        {
          path: "/basicsConfigure",
          component: BasicsConfigure,
          name: "基础数据管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/colorSet",
          component: ColorSet,
          name: "型号颜色管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/faultSet",
          component: FaultSet,
          name: "维修故障管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/faultOffer",
          component: FaultOffer,
          name: "故障报价管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/faultRepair",
          component: FaultRepair,
          name: "维修定价管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/materClass",
          component: MaterClass,
          name: "物料分类管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/materCode",
          component: MaterCode,
          name: "物料编码管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/repairModeManage",
          component: RepairModeManage,
          name: "维修方式管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/materBinding",
          component: MaterBinding,
          name: "物料绑定管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/serviceSku",
          component: ServiceSku,
          name: "服务SKU管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/channelManage",
          component: ChannelManage,
          name: "渠道管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/trashRecoverManage",
          component: TrashRecoverManage,
          name: "废宝类型管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/engineerManage",
          component: EngineerManage,
          name: "工程师等级",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/engineerBasicPackage",
          component: EngineerBasicPackage,
          name: "工程师基础包",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/questionList",
          component: QuestionList,
          name: "问题列表",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/questionFault",
          component: QuestionFault,
          name: "问答故障管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/regionManagerList",
          component: RegionManagerList,
          name: "地区管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/tweetPictures",
          component: TweetPictures,
          name: "图文管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/businessUser",
          component: BusinessUserList,
          name: "2b商户管理",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/modelAdapter",
          component: ModelAdapter,
          name: "小程序型号适配",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/dispatchConfiguration",
          component: DispatchConfiguration,
          name: "派单配置",
          meta: { requireAuth: true, keepAlive: false }
        }
      ]
    },
    {
      //meta: {requireAuth: true} 进入这个路由是需要登陆的
      path: "/purchaseManage",
      component: Home,
      name: "采购管理",
      children: [
        {
          path: "/supplierManage",
          component: SupplierManage,
          name: "供应商管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/returnGoodsManage",
          component: ReturnGoodsManage,
          name: "采购退货管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/returnGoodsInfo",
          component: ReturnGoodsInfo,
          name: "采购退货详情",
          meta: { requireAuth: true }
        },
        {
          path: "/purchaseOrderManage",
          component: PurchaseOrderManage,
          name: "采购订单管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/purchaseOrderInfo",
          component: PurchaseOrderInfo,
          name: "采购订单详情",
          meta: { requireAuth: true }
        },
        {
          path: "/newPurchaseOrder",
          component: NewPurchaseOrder,
          name: "新建采购订单",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/newChangePurchaseOrder",
          component: NewChangePurchaseOrder,
          name: "修改暂存采购订单",
          meta: { requireAuth: true }
        },
        {
          path: "/purchaseOrderChangeManage",
          component: PurchaseOrderChangeManage,
          name: "采购变更管理",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/newPurchaseOrderChangeOrder",
          component: NewPurchaseOrderChangeOrder,
          name: "新建采购变更",
          meta: { requireAuth: true }
        },
        {
          path: "/purchaseOrderChangeInfo",
          component: PurchaseOrderChangeInfo,
          name: "采购变更详情",
          meta: { requireAuth: true }
        },
        {
          path: "/newChangePurchaseOrderChangeOrder",
          component: NewChangePurchaseOrderChangeOrder,
          name: "修改暂存采购变更单",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/storeManage",
      component: Home,
      name: "门店管理列表",
      children: [
        {
          path: "/storeEngineerManage",
          component: StoreEngineerManage,
          name: "工程师管理",
          meta: { requireAuth: true }
        },
        {
          path: "/shopManage",
          component: ShopManage,
          name: "门店管理",
          meta: { requireAuth: true }
        },
        {
          path: "/storeCoupon",
          component: StoreCoupon,
          name: "门店优惠券",
          meta: { requireAuth: true }
        },
        {
          path: "/storeActivity",
          component: StoreActivity,
          name: "门店活动",
          meta: { requireAuth: true }
        },
        {
          path: "/storeSubscriberCoupon",
          component: StoreSubscriberCoupon,
          name: "门店会员优惠券",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      //newPicking  newAccessStore
      path: "/storehouseManage",
      component: Home,
      name: "仓库管理",
      children: [
        {
          path: "/entryManage",
          component: EntryManage,
          name: "维修入库完成",
          meta: { requireAuth: true }
        },
        {
          path: "/outManage",
          component: OutManage,
          name: "维修出库完成",
          meta: { requireAuth: true }
        },
        {
          path: "/unEntryManage",
          component: UnEntryManage,
          name: "取机待入库",
          meta: { requireAuth: true }
        },
        {
          path: "/unOutManage",
          component: UnOutManage,
          name: "取机维修出库",
          meta: { requireAuth: true }
        },
        {
          path: "/residualManage",
          component: ResidualManage,
          name: "废料残值定价",
          meta: { requireAuth: true }
        },
        {
          path: "/newResidual",
          component: NewResidual,
          name: "新建废料残值定价",
          meta: { requireAuth: true }
        },
        {
          path: "/residualManageInfo",
          component: ResidualManageInfo,
          name: "废料残值定价详情",
          meta: { requireAuth: true }
        },
        {
          path: "/pickingManage",
          component: PickingManage,
          name: "领料管理",
          meta: { requireAuth: true }
        },
        {
          path: "/newPicking",
          component: NewPicking,
          name: "新建领料",
          meta: { requireAuth: true }
        },
        {
          path: "/editPicking",
          component: EditPicking,
          name: "领料暂存",
          meta: { requireAuth: true }
        },
        {
          path: "/pickingInfo",
          component: PickingInfo,
          name: "领料详情页",
          meta: { requireAuth: true }
        },
        {
          path: "/returnMaterManage",
          component: ReturnMaterManage,
          name: "退料列表管理",
          meta: { requireAuth: true }
        },
        {
          path: "/returnMaterManageList",
          component: ReturnMaterManageList,
          name: "退料管理",
          meta: { requireAuth: true }
        },
        {
          path: "/returnMaterInfo",
          component: ReturnMaterInfo,
          name: "退料详情",
          meta: { requireAuth: true }
        },
        {
          path: "/newReturnMater",
          component: NewReturnMater,
          name: "新建退料",
          meta: { requireAuth: true }
        },
        {
          path: "/editReturnMater",
          component: EditReturnMater,
          name: "退料暂存",
          meta: { requireAuth: true }
        },
        {
          path: "/returnMaterialSave",
          component: ReturnMaterialSave,
          name: "退料自留管理",
          meta: { requireAuth: true }
        },
        {
          path: "/stockQuery",
          component: StockQuery,
          name: "库存查询",
          meta: { requireAuth: true }
        },
        {
          path: "/stockCheck",
          component: StockCheck,
          name: "仓库库存盘点",
          meta: { requireAuth: true }
        },
        {
          path: "/newStockCheck",
          component: NewStockCheck,
          name: "新建库存",
          meta: { requireAuth: true }
        },
        {
          path: "/stockCheckInfo",
          component: StockCheckInfo,
          name: "库存详情",
          meta: { requireAuth: true }
        },
        {
          path: "/engineerStockQuery",
          component: EngineerStockQuery,
          name: "工程师库存",
          meta: { requireAuth: true }
        },
        {
          path: "/materExchange",
          component: MaterExchange,
          name: "物料流转记录",
          meta: { requireAuth: true }
        },
        {
          path: "/snList",
          component: QuerySn,
          name: "小码生命周期",
          meta: { requireAuth: true }
        },
        {
          path: "/materialSnBinderList",
          component: MaterialSnBinder,
          name: "物料小码绑定",
          meta: { requireAuth: true }
        },
        {
          path: "/scrapProfit",
          component: ScrapProfitList,
          name: "残值利润",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      //newPicking  newAccessStoreOuter
      path: "/storeManageOuter",
      component: Home,
      name: "仓库对外管理",
      children: [
        {
          path: "/accessStoreManage",
          component: AccessStoreManage,
          name: "出入库管理",
          meta: { requireAuth: true }
        },
        {
          path: "/newAccessStore",
          component: NewAccessStore,
          name: "新建出入库",
          meta: { requireAuth: true }
        },
        {
          path: "/editAccessStore",
          component: EditAccessStore,
          name: "出入库暂存",
          meta: { requireAuth: true }
        },
        {
          path: "/accessStoreInfo",
          component: AccessStoreInfo,
          name: "出入库订单详情页",
          meta: { requireAuth: true }
        },
        {
          path: "/materChangeStoreManage",
          component: MaterChangeStoreManage,
          name: "物料转库",
          meta: { requireAuth: true }
        },
        {
          path: "/newMaterChangeStore",
          component: NewMaterChangeStore,
          name: "新建物料转库",
          meta: { requireAuth: true }
        },
        {
          path: "/materChangeStoreInfo",
          component: MaterChangeStoreInfo,
          name: "物料转库详情",
          meta: { requireAuth: true }
        },
        {
          path: "/materDeliveryManage",
          component: MaterDeliveryManage,
          name: "配送发货",
          meta: { requireAuth: true }
        },
        {
          path: "/materDeliveryInfo",
          component: MaterDeliveryInfo,
          name: "配送详情",
          meta: { requireAuth: true }
        },
        {
          path: "/newMaterDelivery",
          component: NewMaterDelivery,
          name: "新建配送",
          meta: { requireAuth: true }
        },
        {
          path: "/materReceiveManage",
          component: MaterReceiveManage,
          name: "配送收货",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/workOrder",
      component: Home,
      name: "工单管理",
      children: [
        {
          path: "/workOrderManage",
          component: WorkOrderManage,
          name: "工单信息(主)",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/workOrderManageOther",
          component: WorkOrderManageOther,
          name: "工单信息",
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "/workOrderInfo",
          component: WorkOrderInfo,
          name: "工单详情(已完成)",
          meta: { requireAuth: true }
        },
        {
          path: "/workOrderInfo_exit",
          component: WorkOrderInfoExit,
          name: "工单详情(未完成)",
          meta: { requireAuth: true }
        },
        {
          path: "/visitRepair",
          component: VisitRepair,
          name: "工单详情",
          meta: { requireAuth: true }
        },
        {
          path: "/visitService",
          component: VisitService,
          name: "工单详情(上门售后)",
          meta: { requireAuth: true }
        },
        {
          path: "/shopRepair",
          component: ShopRepair,
          name: "工单详情(到店维修)",
          meta: { requireAuth: true }
        },
        {
          path: "/shopService",
          component: ShopService,
          name: "工单详情(到店售后)",
          meta: { requireAuth: true }
        },
        {
          path: "/newWorkOrder",
          component: NewWorkOrder,
          name: "新建工单",
          meta: { requireAuth: true }
        },
        {
          path: "/billingManage",
          component: BillingManage,
          name: "开票申请",
          meta: { requireAuth: true }
        },
        {
          path: "/refundManage",
          component: RefundManage,
          name: "退款申请",
          meta: { requireAuth: true }
        },
        {
          path: "/workOrderManageRmk",
          component: WorkOrderManageRmk,
          name: "工单信息(普)",
          meta: { requireAuth: true }
        },
        {
          path: "/workOrderManageShop",
          component: WorkOrderManageShop,
          name: "工单信息(门)",
          meta: { requireAuth: true }
        },
        {
          path: "/stockQueryManage",
          component: StockQueryManage,
          name: "库存查询",
          meta: { requireAuth: true }
        },
        {
          path: "/engineerStockQueryManage",
          component: EngineerStockQueryManage,
          name: "工程师库存",
          meta: { requireAuth: true }
        },
        {
          path: "/quantityCalculation",
          component: QuantityCalculation,
          name: "每日单量",
          meta: { requireAuth: true }
        },
        {
          path: "/orderMap",
          component: OrderMap,
          name: "订单区域",
          meta: { requireAuth: true }
        },
        {
          path: "/orderCoordinateMap",
          component: OrderCoordinateMap,
          name: "订单坐标区域",
          meta: { requireAuth: true }
        },
        {
          path: "/shopStoreOrderMap",
          component: ShopStoreOrderMap,
          name: "门店订单区域",
          meta: { requireAut: true }
        }
      ]
    },
    {
      path: "/dispatchOrder",
      component: Home,
      name: "派单",
      children: [
        {
          path: "/dispatchManage",
          component: DispatchManage,
          name: "派单管理",
          meta: { requireAuth: true }
        },
        {
          path: "/dispatchList",
          component: DispatchList,
          name: "改派汇总",
          meta: { requireAuth: true }
        },
        {
          path: "/unDispatchList",
          component: UnDispatchList,
          name: "待派汇总",
          meta: { requireAuth: true }
        },
        {
          path: "/dispatchLook",
          component: DispatchLook,
          name: "派单看板",
          meta: { requireAuth: true }
        },
        {
          path: "/dispatchReady",
          component: DispatchReady,
          name: "派单预派",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/recovery",
      component: Home,
      name: "回收",
      children: [
        {
          path: "/dispatchManage",
          component: DispatchManage,
          name: "回收管理",
          meta: { requireAuth: true }
        },
        {
          path: "/recoveryProfit",
          component: RecoveryProfit,
          name: "回收利润率",
          meta: { requireAuth: true }
        },
        {
          path: "/recoveryParams",
          component: RecoveryParams,
          name: "回收询价记录",
          meta: { requireAuth: true }
        },
        {
          path: "/recoveryPictures",
          component: RecoveryPictures,
          name: "回收图文配置",
          meta: { requireAuth: true }
        },
        {
          path: "/recoveryShop",
          component: RecoveryShop,
          name: "门店回收",
          meta: { requireAuth: true }
        },
        {
          path: "/recoveryShopApkVersion",
          component: RecoveryShopApkVersion,
          name: "门店apk版本",
          meta: { requireAuth: true }
        }

      ]
    },
    {
      path: "/financialCenter",
      component: Home,
      name: "财务中心",
      children: [
        {
          path: "/fundAuthManage",
          component: FundAuthManage,
          name: "预授权管理",
          meta: { requireAuth: true }
        },
        {
          path: "/refundsManage",
          component: RefundsManage,
          name: "退款管理",
          meta: { requireAuth: true }
        },
        {
          path: "/reconciliationManage",
          component: ReconciliationManage,
          name: "对账管理",
          meta: { requireAuth: true }
        },
        {
          path: "/invocingManage",
          component: InvocingManage,
          name: "开票管理",
          meta: { requireAuth: true }
        },
        {
          path: "/financialInterest",
          component: FinancialInterest,
          name: "财务利润",
          meta: { requireAuth: true }
        },
        {
          path: "/orderDetail",
          component: OrderDetail,
          name: "订单详情",
          meta: { requireAuth: true }
        },
        {
          path: "/engineerOrder",
          component: EngineerOrder,
          name: "单量统计",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/customerManage",
      component: Home,
      name: "客服管理",
      children: [
        {
          path: "/customerServiceManage",
          component: CustomerServiceManage,
          name: "客服人员",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/customerManagement",
      component: Home,
      name: "客户管理",
      children: [
        {
          path: "/customerListManage",
          component: CustomerListManage,
          name: "用户列表",
          meta: { requireAuth: true }
        },
        {
          path: "/customerInfo",
          component: CustomerInfo,
          name: "客户详情",
          meta: { requireAuth: true }
        },
        {
          path: "/subscriber",
          component: BizSubscriber,
          name: "会员用户管理",
          meta: { requireAuth: true }
        },
        {
          path: "/subscriberDetail",
          component: BizSubscriberDetail,
          name: "会员用户详情",
          meta: { requireAuth: true }
        },
        {
          path: "/subscriberCouponHistory",
          component: SubscriberCoupon,
          name: "会员优惠券",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/Home",
      component: Home,
      name: "HomePage",
      leaf: true, //只有一个节点
      // iconCls: 'ios-navigate', //图标样式class
      children: [
        {
          path: "/welcome",
          component: Welcome,
          name: "首页",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/navZuhu",
      component: Home,
      name: "租户管理",
      children: [
        {
          path: "/zuhu",
          component: ZuHu,
          name: "租户信息",
          meta: { requireAuth: true, keepAlive: true }
        },
        {
          path: "/zuhuAllow",
          component: ZuHuAllow,
          name: "租户许可信息",
          meta: { requireAuth: true }
        }
      ]
    },

    {
      path: "/logging",
      component: Home,
      name: "系统日志",
      children: [
        {
          path: "/rizhiLookup",
          component: RizhiLookup,
          name: "日志查询",
          meta: { requireAuth: true }
        },
        {
          path: "/loginLogging",
          component: LoginLogging,
          name: "登录日志",
          meta: { requireAuth: true }
        },
        {
          path: "/errorLogging",
          component: ErrorLogging,
          name: "异常日志",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/setManage",
      component: Home,
      name: "配置项管理",
      // iconCls: 'ios-navigate', //图标样式class
      children: [
        {
          path: "/defaultMenu",
          component: DefaultMenu,
          name: "默认配置项",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      //parameterInfoBusiness
      path: "/systemManage",
      component: Home,
      name: "系统设置",
      // iconCls: 'ios-navigate', //图标样式class
      children: [
        {
          path: "/personZuzhi",
          component: PersonZuzhi,
          name: "人员组织",
          meta: { requireAuth: true }
        },
        {
          path: "/shujuQuery",
          component: ShujuQuery,
          name: "数据权限表",
          meta: { requireAuth: true }
        },
        {
          path: "/roleList",
          component: RoleList,
          name: "角色授权",
          meta: { requireAuth: true }
        },
        {
          path: "/functionAuthorityList",
          component: FunctionAuthorityList,
          name: "菜单权限",
          meta: { requireAuth: true }
        },
        {
          path: "/parameterInfo",
          component: ParameterInfo,
          name: "参数设置",
          meta: { requireAuth: true }
        },
        {
          path: "/parameterInfoBusiness",
          component: ParameterInfoBusiness,
          name: "业务参数",
          meta: { requireAuth: true }
        },
        {
          path: "/messageNotice",
          component: MessageNotice,
          name: "系统公告",
          meta: { requireAuth: true }
        },
        {
          path: "/feishuApprove",
          component: FeishuApprove,
          name: "飞书配置",
          meta: { requireAuth: true }
        },
        {
          path: "/scheduling",
          component: Scheduling,
          name: "任务调度",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/finReport",
      component: Home,
      name: "报表中心",
      children: [
        {
          path: "/orderReport",
          component: OrderReport,
          name: "订单报表",
          meta: { requireAuth: true }
        },
        {
          path: "/bdpReport",
          component: BdpReport,
          name: "全服报表",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      //parameterInfoBusiness
      path: "/activeTable",
      component: Home,
      name: "动态表配置",
      // iconCls: 'ios-navigate', //图标样式class
      children: [
        {
          path: "/extAttrList",
          component: ExtAttrList,
          name: "扩展信息",
          meta: { requireAuth: true }
        }
      ]
    },
    {
      path: "/biz",
      component: Home,
      name: "活动与优惠券",
      children: [
        {
          path: "/BizPrivilegeCard",
          component: BizPrivilegeCard,
          name: "权益卡",
          meta: { requireAuth: true }
        },
        {
          path: "/bizPrivilegePools",
          component: BizPrivilegePool,
          name: "权益池",
          meta: { requireAuth: true }
        },
        {
          path: "/subscriberPrivilege",
          component: SubscriberPrivilege,
          name: "会员权益",
          meta: { requireAuth: true }
        },
        {
          path: "/biz_coupon",
          component: BizCoupon,
          name: "优惠券管理",
          meta: { requireAut: true }
        },
        {
          path: "/biz_coupon_edit",
          component: BizCouponEdit,
          name: "优惠券"
        },
        {
          path: "/biz_activity",
          component: BizActivity,
          name: "活动管理",
          meta: { requireAuth: true }
        },
        {
          path: "/bizGiftCard",
          component: BizGiftCard,
          name: "礼品卡",
          meta: { requireAuth: true }
        },
        {
          path: "/bizGiftCardRecord",
          component: BizGiftCardRecord,
          name: "礼品卡记录",
          meta: { requireAuth: true }
        },
        {
          path: "/bizGiftCardBuyConfig",
          component: BizGiftCardBuyConfig,
          name: "购买配置",
          meta: { requireAuth: true }
        },
        {
          path: "/bizGiftCardOrder",
          component: BizGiftCardOrder,
          name: "礼品卡订单管理",
          meta: { requireAuth: true }
        },
        {
          path: "/bizGiftCardOrderRefund",
          component: BizGiftCardOrderRefund,
          name: "礼品卡退款申请",
          meta: { requireAuth: true }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js